// Copyright (c) Docugami, Inc. All rights reserved.

export enum CoachMarkId {
    AutoAssignDocSet = 'AutoAssignDocSet',
    EmptyDocSets = 'EmptyDocSets'
}

export type CoachMarkLookup = {
    [coachMarkId: string]: boolean
}

export type OrganizationCoachMarkLookup = {
    [orgId: string]: CoachMarkLookup
}
